module.exports = {
          srcSet: __webpack_public_path__ + "cf8b0ae1.jpg"+" 700w"+","+__webpack_public_path__ + "248c3cbd.jpg"+" 1400w"+","+__webpack_public_path__ + "0b1f2d1b.jpg"+" 1944w",
          images:[ {path: __webpack_public_path__ + "cf8b0ae1.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "248c3cbd.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "0b1f2d1b.jpg",width: 1944,height: 1296}],
          src: __webpack_public_path__ + "cf8b0ae1.jpg",
          toString:function(){return __webpack_public_path__ + "cf8b0ae1.jpg"},
          
          width: 700,
          height: 467
        }